// import React, { createContext, useState, useContext, useCallback } from "react";
// import {
//   createNewNewsletter,
//   updateNewsletter,
//   deleteNewsletter,
// } from "../../../../lib/firebase/newsletters/write";
// import { getNewsletter } from "../../../../lib/firebase/newsletters/read";
// import { useNavigate } from "react-router-dom";
// import { Timestamp } from "firebase/firestore";

// const NewsletterFormContext = createContext();

// export function useNewsletterForm() {
//   return useContext(NewsletterFormContext);
// }

// export default function NewsletterFormContextProvider({ children }) {
//   const [data, setData] = useState({ pdfFile: null });
//   const [isFetching, setIsFetching] = useState(false);
//   const [isUpdateLoading, setIsUpdateLoading] = useState(false);
//   const [isDeleteLoading, setIsDeleteLoading] = useState(false);
//   const [successMessage, setSuccessMessage] = useState("");
//   const [error, setError] = useState("");
//   const [isDone, setIsDone] = useState(false);
//   const [validationErrors, setValidationErrors] = useState({});
//   const navigate = useNavigate();

//   const handleData = useCallback((key, value) => {
//     setIsDone(false);
//     setError("");
//     setValidationErrors((prev) => ({ ...prev, [key]: "" }));
//     setData((prevData) => ({
//       ...prevData,
//       [key]: value,
//     }));
//   }, []);

//   const resetForm = useCallback(() => {
//     setData({
//       pdfFile: null,
//       publicationName: "",
//       articleTitle: "",
//       volume: "",
//       daysOfPublication: "",
//       metaTitle: "",
//       metaDescription: "",
//       categoryId: "",
//       productType: "Newsletter",
//       timestamp: Timestamp.now(),
//     });
//     setError("");
//     setIsDone(false);
//     setValidationErrors({});
//     setSuccessMessage("");
//   }, []);

//   const validateForm = useCallback(() => {
//     const errors = {};
//     if (!data.publicationName)
//       errors.publicationName = "Publication Name is required";
//     if (!data.articleTitle) errors.articleTitle = "Article Title is required";
//     if (!data.volume || data.volume.trim() === "")
//       errors.volume = "Volume is required and cannot be empty";
//     if (!data.daysOfPublication) {
//       errors.daysOfPublication = "Days of Publication is required";
//     } else {
//       const datePattern =
//         /^(?:\d{1,2}\s(January|February|March|April|May|June|July|August|September|October|November|December),\s\d{4}|(January|February|March|April|May|June|July|August|September|October|November|December),\s\d{4}|(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\/(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec),\s\d{4})$/;
//       if (!datePattern.test(data.daysOfPublication)) {
//         errors.daysOfPublication =
//           "Invalid date format. Use 'DD Month, YYYY', 'Month, YYYY', or 'Mon/Mon, YYYY' (e.g., '26 August, 2025', 'August, 2025', or 'Mar/Apr, 2025')";
//       }
//     }
//     if (!data.metaTitle) errors.metaTitle = "Meta Title is required";
//     if (!data.metaDescription)
//       errors.metaDescription = "Meta Description is required";
//     if (!data.categoryId) errors.categoryId = "Category ID is required";
//     if (!data.pdfFile && !data.pdfUrl) errors.pdfFile = "PDF is required";

//     setValidationErrors(errors);
//     return Object.keys(errors).length === 0;
//   }, [data]);

//   const handleCreate = useCallback(
//     async (collectionName = "Newsletter") => {
//       if (!validateForm()) {
//         setError("Please fill all required fields.");
//         return;
//       }
//       setError("");
//       setIsUpdateLoading(true);
//       setIsDone(false);
//       try {
//         // Generate document ID from articleTitle and volume
//         const docId = `${data.articleTitle
//           .toLowerCase()
//           .replace(/\s+/g, "-")}-${data.volume}`;
//         const dataToSave = { ...data, id: docId }; // Include all fields, including publicationName
//         await createNewNewsletter({ data: dataToSave, collectionName });
//         setIsDone(true);
//         setSuccessMessage("Newsletter created successfully!");
//         setTimeout(() => {
//           setSuccessMessage("");
//           resetForm();
//         }, 1000);
//       } catch (error) {
//         console.error("Create Error:", error);
//         setError(
//           error.message ||
//             "Failed to create newsletter. Please check your input and try again."
//         );
//       } finally {
//         setIsUpdateLoading(false);
//       }
//     },
//     [data, validateForm, resetForm]
//   );

//   const handleUpdate = useCallback(
//     async (collectionName = "Newsletter") => {
//       if (!validateForm()) {
//         setError("Please fill all required fields.");
//         return;
//       }
//       setError("");
//       setIsUpdateLoading(true);
//       setIsDone(false);
//       try {
//         if (!data?.id) throw new Error("No ID provided for update");
//         // Update with existing ID, include all fields
//         await updateNewsletter({ data, collectionName });
//         setIsDone(true);
//         setSuccessMessage("Newsletter updated successfully!");
//         setTimeout(() => {
//           setSuccessMessage("");
//           navigate("/admin/newsletters");
//         }, 1000);
//       } catch (error) {
//         console.error("Update Error:", error);
//         setError(error.message || "Failed to update newsletter");
//       } finally {
//         setIsUpdateLoading(false);
//       }
//     },
//     [data, validateForm, navigate]
//   );

//   const handleDelete = useCallback(
//     async (id, collectionName = "Newsletter") => {
//       setError("");
//       setIsDeleteLoading(true);
//       setIsDone(false);
//       try {
//         if (!id) throw new Error("No ID provided for deletion");
//         await deleteNewsletter(id, collectionName);
//         setIsDone(true);
//         setSuccessMessage("Newsletter deleted successfully!");
//         setTimeout(() => {
//           setSuccessMessage("");
//           navigate("/admin/newsletters");
//         }, 1000);
//       } catch (error) {
//         console.error("Delete Error:", error);
//         setError(error.message || "Failed to delete newsletter");
//       } finally {
//         setIsDeleteLoading(false);
//       }
//     },
//     [navigate]
//   );

//   const fetchData = useCallback(async (id, collectionName = "Newsletter") => {
//     setError("");
//     setIsFetching(true);
//     setIsDone(false);
//     try {
//       const res = await getNewsletter(id, collectionName);
//       if (res) {
//         const fetchedData = {
//           id: res.id,
//           publicationName: res.publicationName || "",
//           articleTitle: res.articleTitle || "",
//           volume: res.volume || "",
//           daysOfPublication: res.daysOfPublication || "",
//           metaTitle: res.metaTitle || "",
//           metaDescription: res.metaDescription || "",
//           categoryId: res.categoryId || "",
//           pdfUrl: res.pdfUrl || "",
//           pdfFile: null,
//           productType: res.productType || "Newsletter",
//           timestamp: res.timestamp || Timestamp.now(),
//         };
//         setData(fetchedData);
//       } else {
//         throw new Error(
//           `No newsletter found for id ${id}. Please check if the newsletter exists in Firestore.`
//         );
//       }
//     } catch (error) {
//       console.error("Fetch Error:", error);
//       setError(
//         error.message ||
//           "Failed to fetch newsletter. The newsletter may not exist or there was a server error."
//       );
//     } finally {
//       setIsFetching(false);
//     }
//   }, []);

//   return (
//     <NewsletterFormContext.Provider
//       value={{
//         data,
//         handleData,
//         isFetching,
//         isUpdateLoading,
//         isDeleteLoading,
//         error,
//         isDone,
//         successMessage,
//         handleCreate,
//         handleUpdate,
//         handleDelete,
//         fetchData,
//         resetForm,
//         validationErrors,
//       }}
//     >
//       {children}
//     </NewsletterFormContext.Provider>
//   );
// }

// import React, { createContext, useState, useContext, useCallback } from "react";
// import {
//   createNewNewsletter,
//   updateNewsletter,
//   deleteNewsletter,
// } from "../../../../lib/firebase/newsletters/write";
// import { getNewsletter } from "../../../../lib/firebase/newsletters/read";
// import { useNavigate } from "react-router-dom";
// import { Timestamp } from "firebase/firestore";

// const NewsletterFormContext = createContext();

// export function useNewsletterForm() {
//   return useContext(NewsletterFormContext);
// }

// export default function NewsletterFormContextProvider({ children }) {
//   const [data, setData] = useState({ pdfFile: null });
//   const [isFetching, setIsFetching] = useState(false);
//   const [isUpdateLoading, setIsUpdateLoading] = useState(false);
//   const [isDeleteLoading, setIsDeleteLoading] = useState(false);
//   const [successMessage, setSuccessMessage] = useState("");
//   const [error, setError] = useState("");
//   const [isDone, setIsDone] = useState(false);
//   const [validationErrors, setValidationErrors] = useState({});
//   const navigate = useNavigate();

//   const handleData = useCallback((key, value) => {
//     setIsDone(false);
//     setError("");
//     setValidationErrors((prev) => ({ ...prev, [key]: "" }));
//     setData((prevData) => ({
//       ...prevData,
//       [key]: value,
//     }));
//   }, []);

//   const resetForm = useCallback(() => {
//     setData({
//       pdfFile: null,
//       publicationName: "",
//       articleTitle: "",
//       volume: "",
//       daysOfPublication: "",
//       shootingDate: "",
//       metaTitle: "",
//       metaDescription: "",
//       categoryId: "",
//       productType: "Newsletter",
//       timestamp: Timestamp.now(),
//     });
//     setError("");
//     setIsDone(false);
//     setValidationErrors({});
//     setSuccessMessage("");
//   }, []);

//   const validateForm = useCallback(() => {
//     const errors = {};
//     if (!data.publicationName)
//       errors.publicationName = "Publication Name is required";
//     if (!data.articleTitle) errors.articleTitle = "Article Title is required";
//     if (!data.volume || data.volume.trim() === "")
//       errors.volume = "Volume is required and cannot be empty";
//     if (!data.daysOfPublication) {
//       errors.daysOfPublication = "Days of Publication is required";
//     } else {
//       const datePattern =
//         /^(?:\d{1,2}\s(January|February|March|April|May|June|July|August|September|October|November|December),\s\d{4}|(January|February|March|April|May|June|July|August|September|October|November|December),\s\d{4}|(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\/(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec),\s\d{4})$/;
//       if (!datePattern.test(data.daysOfPublication)) {
//         errors.daysOfPublication =
//           "Invalid date format. Use 'DD Month, YYYY', 'Month, YYYY', or 'Mon/Mon, YYYY' (e.g., '26 August, 2025', 'August, 2025', or 'Mar/Apr, 2025')";
//       }
//     }
//     if (!data.shootingDate) errors.shootingDate = "Shooting Date is required";
//     if (!data.metaTitle) errors.metaTitle = "Meta Title is required";
//     if (!data.metaDescription)
//       errors.metaDescription = "Meta Description is required";
//     if (!data.categoryId) errors.categoryId = "Category ID is required";
//     if (!data.pdfFile && !data.pdfUrl) errors.pdfFile = "PDF is required";

//     setValidationErrors(errors);
//     return Object.keys(errors).length === 0;
//   }, [data]);

//   const handleCreate = useCallback(
//     async (collectionName = "Newsletter") => {
//       if (!validateForm()) {
//         setError("Please fill all required fields.");
//         return;
//       }
//       setError("");
//       setIsUpdateLoading(true);
//       setIsDone(false);
//       try {
//         // Generate document ID from articleTitle and volume
//         const docId = `${data.articleTitle
//           .toLowerCase()
//           .replace(/\s+/g, "-")}-${data.volume}`;
//         // Include all fields in dataToSave
//         const dataToSave = { ...data, id: docId, timestamp: Timestamp.now() };
//         await createNewNewsletter({ data: dataToSave, collectionName });
//         setIsDone(true);
//         setSuccessMessage("Newsletter created successfully!");
//         setTimeout(() => {
//           setSuccessMessage("");
//           resetForm();
//         }, 2000);
//       } catch (error) {
//         console.error("Create Error:", error);
//         setError(
//           error.message ||
//             "Failed to create newsletter. Please check your input and try again."
//         );
//       } finally {
//         setIsUpdateLoading(false);
//       }
//     },
//     [data, validateForm, resetForm]
//   );

//   const handleUpdate = useCallback(
//     async (collectionName = "Newsletter") => {
//       if (!validateForm()) {
//         setError("Please fill all required fields.");
//         return;
//       }
//       setError("");
//       setIsUpdateLoading(true);
//       setIsDone(false);
//       try {
//         if (!data?.id) throw new Error("No ID provided for update");
//         // Include all fields in dataToSave
//         const dataToSave = { ...data, timestamp: Timestamp.now() };
//         await updateNewsletter({ data: dataToSave, collectionName });
//         setIsDone(true);
//         setSuccessMessage("Newsletter updated successfully!");
//         setTimeout(() => {
//           setSuccessMessage("");
//           navigate("/admin/newsletters");
//         }, 2000);
//       } catch (error) {
//         console.error("Update Error:", error);
//         setError(error.message || "Failed to update newsletter");
//       } finally {
//         setIsUpdateLoading(false);
//       }
//     },
//     [data, validateForm, navigate]
//   );

//   const handleDelete = useCallback(
//     async (id, collectionName = "Newsletter") => {
//       setError("");
//       setIsDeleteLoading(true);
//       setIsDone(false);
//       try {
//         if (!id) throw new Error("No ID provided for deletion");
//         await deleteNewsletter(id, collectionName);
//         setIsDone(true);
//         setSuccessMessage("Newsletter deleted successfully!");
//         setTimeout(() => {
//           setSuccessMessage("");
//           navigate("/admin/newsletters");
//         }, 2000);
//       } catch (error) {
//         console.error("Delete Error:", error);
//         setError(error.message || "Failed to delete newsletter");
//       } finally {
//         setIsDeleteLoading(false);
//       }
//     },
//     [navigate]
//   );

//   const fetchData = useCallback(async (id, collectionName = "Newsletter") => {
//     setError("");
//     setIsFetching(true);
//     setIsDone(false);
//     try {
//       const res = await getNewsletter(id, collectionName);
//       if (res) {
//         const fetchedData = {
//           id: res.id,
//           publicationName: res.publicationName || "",
//           articleTitle: res.articleTitle || "",
//           volume: res.volume || "",
//           daysOfPublication: res.daysOfPublication || "",
//           shootingDate: res.shootingDate || "",
//           metaTitle: res.metaTitle || "",
//           metaDescription: res.metaDescription || "",
//           categoryId: res.categoryId || "",
//           pdfUrl: res.pdfUrl || "",
//           pdfFile: null,
//           productType: res.productType || "Newsletter",
//           timestamp: res.timestamp || Timestamp.now(),
//         };
//         setData(fetchedData);
//       } else {
//         throw new Error(
//           `No newsletter found for id ${id}. Please check if the newsletter exists in Firestore.`
//         );
//       }
//     } catch (error) {
//       console.error("Fetch Error:", error);
//       setError(
//         error.message ||
//           "Failed to fetch newsletter. The newsletter may not exist or there was a server error."
//       );
//     } finally {
//       setIsFetching(false);
//     }
//   }, []);

//   return (
//     <NewsletterFormContext.Provider
//       value={{
//         data,
//         handleData,
//         isFetching,
//         isUpdateLoading,
//         isDeleteLoading,
//         error,
//         isDone,
//         successMessage,
//         handleCreate,
//         handleUpdate,
//         handleDelete,
//         fetchData,
//         resetForm,
//         validationErrors,
//       }}
//     >
//       {children}
//     </NewsletterFormContext.Provider>
//   );
// }

import React, { createContext, useState, useContext, useCallback } from "react";
import {
  createNewNewsletter,
  updateNewsletter,
  deleteNewsletter,
} from "../../../../lib/firebase/newsletters/write";
import { getNewsletter } from "../../../../lib/firebase/newsletters/read";
import { useNavigate } from "react-router-dom";
import { Timestamp } from "firebase/firestore";

const NewsletterFormContext = createContext();

export function useNewsletterForm() {
  return useContext(NewsletterFormContext);
}

export default function NewsletterFormContextProvider({ children }) {
  const [data, setData] = useState({ pdfFile: null });
  const [isFetching, setIsFetching] = useState(false);
  const [isUpdateLoading, setIsUpdateLoading] = useState(false);
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [error, setError] = useState("");
  const [isDone, setIsDone] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const navigate = useNavigate();

  const handleData = useCallback((key, value) => {
    setIsDone(false);
    setError("");
    setValidationErrors((prev) => ({ ...prev, [key]: "" }));
    setData((prevData) => ({
      ...prevData,
      [key]: value,
    }));
  }, []);

  const resetForm = useCallback(() => {
    setData({
      pdfFile: null,
      publicationName: "",
      articleTitle: "",
      volume: "",
      daysOfPublication: "",
      sortedDate: "",
      metaTitle: "",
      metaDescription: "",
      categoryId: "",
      productType: "Newsletter",
      timestamp: Timestamp.now(),
    });
    setError("");
    setIsDone(false);
    setValidationErrors({});
    setSuccessMessage("");
  }, []);

  const validateForm = useCallback(() => {
    const errors = {};
    if (!data.publicationName)
      errors.publicationName = "Publication Name is required";
    if (!data.articleTitle) errors.articleTitle = "Article Title is required";
    if (!data.volume || data.volume.trim() === "")
      errors.volume = "Volume is required and cannot be empty";
    if (!data.daysOfPublication) {
      errors.daysOfPublication = "Days of Publication is required";
    } else {
      const datePattern =
        /^(?:\d{1,2}\s(January|February|March|April|May|June|July|August|September|October|November|December),\s\d{4}|(January|February|March|April|May|June|July|August|September|October|November|December),\s\d{4}|(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\/(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec),\s\d{4})$/;
      if (!datePattern.test(data.daysOfPublication)) {
        errors.daysOfPublication =
          "Invalid date format. Use 'DD Month, YYYY', 'Month, YYYY', or 'Mon/Mon, YYYY' (e.g., '26 August, 2025', 'August, 2025', or 'Mar/Apr, 2025')";
      }
    }
    if (!data.sortedDate) errors.sortedDate = "Sorted Date is required";
    if (!data.metaTitle) errors.metaTitle = "Meta Title is required";
    if (!data.metaDescription)
      errors.metaDescription = "Meta Description is required";
    if (!data.categoryId) errors.categoryId = "Category ID is required";
    if (!data.pdfFile && !data.pdfUrl) errors.pdfFile = "PDF is required";

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  }, [data]);

  const handleCreate = useCallback(
    async (collectionName = "Newsletter") => {
      if (!validateForm()) {
        setError("Please fill all required fields.");
        return;
      }
      setError("");
      setIsUpdateLoading(true);
      setIsDone(false);
      try {
        // Generate document ID from articleTitle and volume
        const docId = `${data.articleTitle
          .toLowerCase()
          .replace(/\s+/g, "-")}-${data.volume}`;
        // Convert sortedDate to Firestore Timestamp
        const dataToSave = {
          ...data,
          id: docId,
          timestamp: Timestamp.now(),
          sortedDate: data.sortedDate
            ? Timestamp.fromDate(new Date(data.sortedDate))
            : null,
        };
        await createNewNewsletter({ data: dataToSave, collectionName });
        setIsDone(true);
        setSuccessMessage("Newsletter created successfully!");
        setTimeout(() => {
          setSuccessMessage("");
          navigate("/admin/newsletters");
        }, 3000);
      } catch (error) {
        console.error("Create Error:", error);
        setError(
          error.message ||
            "Failed to create newsletter. Please check your input and try again."
        );
      } finally {
        setIsUpdateLoading(false);
      }
    },
    [data, validateForm, navigate]
  );

  const handleUpdate = useCallback(
    async (collectionName = "Newsletter") => {
      if (!validateForm()) {
        setError("Please fill all required fields.");
        return;
      }
      setError("");
      setIsUpdateLoading(true);
      setIsDone(false);
      try {
        if (!data?.id) throw new Error("No ID provided for update");
        // Convert sortedDate to Firestore Timestamp
        const dataToSave = {
          ...data,
          timestamp: Timestamp.now(),
          sortedDate: data.sortedDate
            ? Timestamp.fromDate(new Date(data.sortedDate))
            : null,
        };
        await updateNewsletter({ data: dataToSave, collectionName });
        setIsDone(true);
        setSuccessMessage("Newsletter updated successfully!");
        setTimeout(() => {
          setSuccessMessage("");
          navigate("/admin/newsletters");
        }, 3000);
      } catch (error) {
        console.error("Update Error:", error);
        setError(error.message || "Failed to update newsletter");
      } finally {
        setIsUpdateLoading(false);
      }
    },
    [data, validateForm, navigate]
  );

  const handleDelete = useCallback(
    async (id, collectionName = "Newsletter") => {
      setError("");
      setIsDeleteLoading(true);
      setIsDone(false);
      try {
        if (!id) throw new Error("No ID provided for deletion");
        await deleteNewsletter(id, collectionName);
        setIsDone(true);
        setSuccessMessage("Newsletter deleted successfully!");
        setTimeout(() => {
          setSuccessMessage("");
          navigate("/admin/newsletters");
        }, 3000);
      } catch (error) {
        console.error("Delete Error:", error);
        setError(error.message || "Failed to delete newsletter");
      } finally {
        setIsDeleteLoading(false);
      }
    },
    [navigate]
  );

  const fetchData = useCallback(async (id, collectionName = "Newsletter") => {
    setError("");
    setIsFetching(true);
    setIsDone(false);
    try {
      const res = await getNewsletter(id, collectionName);
      if (res) {
        const fetchedData = {
          id: res.id,
          publicationName: res.publicationName || "",
          articleTitle: res.articleTitle || "",
          volume: res.volume || "",
          daysOfPublication: res.daysOfPublication || "",
          sortedDate: res.sortedDate
            ? res.sortedDate.toDate().toISOString().split("T")[0]
            : "",
          metaTitle: res.metaTitle || "",
          metaDescription: res.metaDescription || "",
          categoryId: res.categoryId || "",
          pdfUrl: res.pdfUrl || "",
          pdfFile: null,
          productType: res.productType || "Newsletter",
          timestamp: res.timestamp || Timestamp.now(),
        };
        setData(fetchedData);
      } else {
        throw new Error(
          `No newsletter found for id ${id}. Please check if the newsletter exists in Firestore.`
        );
      }
    } catch (error) {
      console.error("Fetch Error:", error);
      setError(
        error.message ||
          "Failed to fetch newsletter. The newsletter may not exist or there was a server error."
      );
    } finally {
      setIsFetching(false);
    }
  }, []);

  return (
    <NewsletterFormContext.Provider
      value={{
        data,
        handleData,
        isFetching,
        isUpdateLoading,
        isDeleteLoading,
        error,
        isDone,
        successMessage,
        handleCreate,
        handleUpdate,
        handleDelete,
        fetchData,
        resetForm,
        validationErrors,
      }}
    >
      {children}
    </NewsletterFormContext.Provider>
  );
}
